import React, { useRef } from 'react'
import { Bar } from 'react-chartjs-2'
import { Grid, Typography } from '@mui/material'
import '../../../styles/report.css'

/** 
 * 
 * This component is expecting the following input. 


*/

const RYGGHorizontalBar = (props) => {
    //console.log('rygghorizontalbar.js', props.displayValues)
    const componentdata = [...props.displayValues.Values].sort((a, b) => { return parseInt(a.Order) - parseInt(b.Order) })
    const chartRef = useRef(null);
    let graphcolors = ['#209D70', '#FEC957', '#E6323A', '#c0c0c0']
    const lables = ['Participation Graph']


    const dataset = componentdata.map(val => {
        return {
            label: [val.Order === '10' ? 'DOING WELL' : val.Order === '20' ? 'CAUTION' : val.Order === '30' ? 'HIGH RISK' : "UNKNOWN"]
            , data: [Math.floor(parseInt((val.Distribution ? val.Distribution : val.SegmentLabel1),0))]
            , backgroundColor: [val.Color]
            , barThickness: 12

        }
    }).filter(n => n)



    const sum = (key) => {
        return this.reduce((a, b) => a + (b[key] || 0), 0);
    }
    // if max isnt defined, the bar will not be the appropriate length
    const MaxValue = 100

    // dynamically create grid / center values    
    const GridDisplay_Bottom = () => {
        return (
            <Grid container columns={5 * (data.length)} direction="row" alignItems="center" justifyContent="center">
                {
                    dataset.map((x, i) => {
                        return (
                           
                                <Grid item xs={5}>
                                    <Grid container direction="row" alignItems="center" justifyContent="center">
                                        <Grid item xs={9}>
                                            <Typography variant="body2" align="right" fontWeight="bold" color={x.backgroundColor[0]}>{x.label[0]}</Typography>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Typography variant="body2" align="left" fontWeight="bold" color={x.backgroundColor[0]}>({x.data[0]})</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
               
                        )
                    })
                }
            </Grid>
        )
    }
    const GridDisplay_Top = () => {
        return (
            <Grid container columns={dataset.length * 5} direction="row" alignItems="center" justifyContent="center">
                {
                    dataset.map((x, i) => {
                        return (
                            <Grid item xs={5} >
                                    <Typography variant="body2" align="center" fontWeight="bold" color={x.backgroundColor[0]}>{Math.floor((x.data[0] / MaxValue) * 100) == 0 ? "" : String(Math.floor((x.data[0] / MaxValue) * 100)) + "%" }</Typography>

                            </Grid>
                        )
                    })
                }
            </Grid>
        )
    }

    const data = {
        labels: lables,
        datasets: dataset
    }

    const config = {
        type: 'bar',
        data: data,
        options: {
            indexAxis: 'y',
            maintainAspectRatio: false,
            scales: {
                y: {
                    max: 100,
                    beginAtZero: true,                    
                    grid: {
                        display: false //turns off grid lines
                        , drawBorder: false  //turns off border lines
                    },
                    ticks: {
                        display: false // turns off values on axis
                    }
                    , stacked: true

                },
                x: {
                    max: 100,
                    grid: {
                        display: false //turns off grid lines
                        , drawBorder: false  //turns off border lines
                    }
                    , ticks: {
                        display: false // turns off values on axis
                    }
                    , stacked: true
                }
            },
            plugins: {
                legend: {
                    display: false
                }
            },

        }
    }



    return (

        <Grid container direction="row" alignItems="center" justifyContent="start" spacing={0}>
            <Grid item xs={12} >
                <Typography variant="body2" fontWeight="500">{props.displayValues.Label}</Typography>
            </Grid>
            <Grid item xs={12} alignItems="stretch" justifyContent="start" sx={{ height: "50px", width: "100%" }} mt={-1}>
                <Bar
                    ref={chartRef}
                    data={data}
                    options={config.options}
                />
            </Grid>
            <Grid item xs={12} mt={-2}>
                <GridDisplay_Top />
            </Grid>
        </Grid>

    )
}

export default RYGGHorizontalBar